<template>
  <div id="app">
    <v-app>
      <router-view class="" />
      <CookieBanner />
    </v-app>
  </div>
</template>

<style>
:root {
  /* 🎨 Цвета */
  --color-primary: #154734;
  --color-primary-1: #F2E4B5;
  --color-primary-dark: #005635;
  --color-primary-light: #008557;
  --color-primary-btn: #007749;
  --color-primary-codepopup: #383733;
  --color-primary-popup: #00483A;
  --color-white: #FFFFFF;
  --color-accent: #F1E4B2;
  --color-number: #F1E4B2;
  --color-text-main: #FEF8E1;
  --color-role-bg: #114b35;
  --color-error: #eb5757;
  --color-error-dark: #ad0202;
  --color-black: #020202;
  --color-placeholder: rgba(21, 71, 52, 0.7);

  /* 🔤 Шрифты */
  --font-family: "jj2book", sans-serif;
  --font-family-regular: "jj2book", sans-serif;
  --font-family-book: "jj2book", sans-serif;
  --font-family-bold: "OswaldBold", sans-serif;
  --font-family-title: "OswaldBold", sans-serif;
  --font-family-heading: "OswaldBold", sans-serif;
  --font-family-oswald: "OswaldBold", sans-serif;
  --font-family-light: "jj2light", sans-serif;
  --font-family-medium: "jj2book", sans-serif;
  --font-family-serif: "Trivia", serif;
  --font-family-addition: "HelveticaNeueCyr", sans-serif;
  --font-family-legal: "HelveticaNeueCyr", sans-serif;

  /* 📏 Размеры шрифтов */
  --font-size-xxl: 40px;
  --font-size-xl: 36px;
  --font-size-lg: 24px;
  --font-size-md: 20px;
  --font-size-sm: 18px;
  --font-size-xs: 16px;
  --font-size-xxs: 14px;
  --font-size-xxxs: 12px;

  /* 📦 Отступы и радиусы */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 20px;

  --padding-sm: 10px;
  --padding-md: 20px;
  --padding-lg: 42px;

  /* 🖱️ Эффекты */
  --transition-fast: 0.15s ease-out;
  --transition-normal: 0.3s ease-in-out;
  --transition-slow: 0.4s ease;
  --box-shadow-btn: 0 4px 10px rgba(0, 119, 73, 0.35);
  --box-shadow-btn-hover: 0 6px 15px rgba(0, 119, 73, 0.45);
  --box-shadow-btn-active: 0 2px 5px rgba(0, 119, 73, 0.4);
}
</style>

<script>
import CookieBanner from '@/components/CookieBanner.vue';

export default {
  name: "App",
  components: {
    CookieBanner
  }
};
</script>
